module.exports = __webpack_public_path__ + "img/重新生成.7c9e8565.svg";